var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bo-cell-number',{attrs:{"decimal":_vm.decimal,"currency":_vm.currency,"negative":_vm.negative,"min":_vm.min,"max":_vm.max,"readonly":!_vm.editable,"editable":_vm.editable,"id":_vm.id,"value":_vm.value,"eager":_vm.eager,"inputStyle":_vm.inputStyle},on:{"change":_vm.changedValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }